import React from "react";
import SingleDocument from "./SingleDocument";
import { BackNextButton } from "../../../../../common";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
const Upload = ({ onNext, onSkip }) => {
  const { financialData } = useSelector((state) => state.company);
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    // e.preventDefault();
      navigate("/dashboard/my-companies");
  };

  return (
    <div className="mt-5 mr-20 ">
      {" "}
      <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2">
        Upload Document
      </h3>
      <div className="border border-slate rounded-lg p-6 mb-6 w-[380px] sm:w-[400px] md:w-[700px] lg:w-[800px]">
        {" "}
        <SingleDocument onFileSelect={handleSubmit} />
      </div>
      <BackNextButton
        onNext={handleSubmit}
        onSkip={() => navigate("/dashboard/my-companies")}
        isLoading={false}
      />
    </div>
  );
};

export default Upload;
